// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileArrowDownRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileArrowDownRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V21H19V7L14 3H5ZM8.00452 10.0039H9.50452V14.0131H14.2895L12.6345 12.3581L13.6952 11.2975L17.2307 14.833L16.1701 15.8937L16.1661 15.8898L13.6673 18.3886L12.6067 17.3279L14.4214 15.5131H7.99854V14.0131H8.00452V10.0039Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileArrowDownRight.js.map